<template>
	<div id="lock" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">Rollen</section>
				</header>
				<header class="card-header" style="background-color:#eeeeee;padding: 12px;">
					<nav class="level">
						<div class="level-left">
							<div class="level-item">
								<b-field>
									<a class="button is-primary" @click="newRole()">
										<b-icon icon="plus-circle-outline"></b-icon>
										<span>Nieuwe Rol</span>
									</a>
								</b-field>
							</div>
						</div>
					</nav>
				</header>
				<div style="padding:5px;">
					<b-table
						:data="Roles"
						:bordered="false"
						:narrowed="true"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
						default-sort="tbl_school.schoolnumber"
					>
						<template slot-scope="props">
							<b-table-column width="40">
								<a class="button is-warning is-small" @click="handleClick(props.row.id)">
									<b-icon icon="pencil"></b-icon>
								</a>
							</b-table-column>
							<b-table-column field="id" label="ID">{{ props.row.id }}</b-table-column>
							<b-table-column field="name" label="Rol">{{ props.row.name }}</b-table-column>


						</template>
					</b-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "lock",

	data: function() {
		return {
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			Roles: [],
			Schools: [],
			selected_roles: [],
			selected_role: null,
			selected_firstlogin: [],
			boards: [],
			selected_locked: [],
			selected_school: null,
			Roles: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 12
		};
	},
	created() {
		this.selected_school = 0;
		this.selected_role = 0;
		this.getSchools();
		this.getRoles();
	},
	watch: {
		selected_role: function(obj, value) {
			console.log("One of the selected role changed!");
			this.getRoles();
		},
		selected_school: function() {
			this.getRoles();
		}
	},
	computed: {},
	methods: {
		handleClick(id) {
			console.log("userid: " + id);
			console.log(this.user.data);
			this.$router.push({
				path: "/roles/update/" + id
			});
		},
		newRole() {
			this.$router.push({
				path: "/roles/new"
			});
		},
		role_save(id, value) {
			console.log(id);
			console.log(value);

			var self = this;
			this.$nextTick(function() {
				// DOM is now updated
				// `this` is bound to the current instance
				console.log(self.selected_roles);

				instance
					.post("/userrol-update", {
						user_id: id,
						role_id: value
					})
					.then(function(response) {
						//console.log(response.data.data);
					});
			});
		},
		getRoles: function() {
			var self = this;

			this.params = this.$route.params;
			self.loading = true;
			instance
				.get("/role")
				.then(function(response) {

					self.Roles = response.data.data;

					self.loading = false;
					console.log(self.selected_roles);
				});
		},
		getRoles: function() {
			var self = this;

			//console.log(this.selected_class);
			this.params = this.$route.params;

			instance.get("/role").then(function(response) {
				console.log(response.data.data);
				console.log(self.Roles);
				var roles = _.sortBy(response.data.data, [
					function(o) {
						return o.id;
					}
				]);

				self.Roles = roles;

				self.selected_school = 0;
				//self.getRoles(value);
			});
		},
		getSchools: function() {
			var self = this;
			self.loading = true;
			instance.get("/school").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);
				console.log(self.Schools);

				var schools = _.remove(response.data.data, function(n) {
					return n.schoolnumber > 0;
				});
				schools = _.sortBy(schools, [
					function(o) {
						return o.schoolnumber;
					}
				]);
				self.Schools = schools;

				self.loading = false;
			});
		}
	}
};
</script>
<style>
</style>
